var $db5c63cb8d95d7a4$exports = {};
$db5c63cb8d95d7a4$exports = {
  "pending": "\u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1"
};
export { $db5c63cb8d95d7a4$exports as default };